import {getStore} from 'src/v2/state/store';
import {Text} from 'src/v2/components/common/Text';
import {LinkTitleWrapper} from 'src/v2/components/screen/link/LinkTitleWrapper';
import {useAmountDisplay} from 'src/v2/state/useAmountDisplay';

import {message, useIntl} from '@sail/intl';
import {view} from '@sail/ui';

const messages = {
  title: message<{
    businessName: React.ReactNode;
    amount: React.ReactNode;
  }>({
    id: 'crypto.payins.v2.heading.pay_title_small',
    description: 'Compact one-line header showing business name and amount',
    defaultMessage: 'Pay {businessName} {amount}',
  }),

  genericTitle: message<{
    amount: React.ReactNode;
  }>({
    id: 'crypto.payins.v2.heading.pay_with_crypto_amount',
    description: 'Generic header showing the payment amount',
    defaultMessage: 'Pay with crypto {amount}',
  }),
};

export const PayTitle = () => {
  const intl = useIntl();
  const store = getStore();

  const businessName = store.useSelector(
    (state) => state.merchantBranding.businessName,
  );
  const useGenericTitle = store.useSelector(
    (state) => state.featureFlags.crypto_payins_generic_payment_title,
  );
  const consumerAccount = store.useSelector((state) => state.consumerAccount);

  const amountDisplay = useAmountDisplay();
  const titleText = useGenericTitle
    ? intl.formatMessage(messages.genericTitle, {amount: amountDisplay})
    : intl.formatMessage(messages.title, {
        businessName,
        amount: amountDisplay,
      });
  const title = (
    <Text type="labelEmphasized" css={{color: 'text'}}>
      {titleText}
    </Text>
  );

  if (consumerAccount) {
    return <LinkTitleWrapper>{title}</LinkTitleWrapper>;
  }

  return (
    <view.div
      css={{
        stack: 'y',
        alignX: 'center',
        alignY: 'center',
      }}
    >
      {title}
    </view.div>
  );
};
